import { withInstall } from '@element-plus/utils'
import Watermark from './src/watermark.vue'

export const ElWatermark = withInstall(Watermark)
export default ElWatermark

export * from './src/watermark'
